import { BaseBffHttpService } from './BaseBffHttpService';

class CommentsService extends BaseBffHttpService {
  protected readonly basePath = '';

  getComments(videoId: string): Promise<Response> {
    return this.get(`${videoId}/comment`);
  }

  postMediaComment(videoId: string, body: FormData): Promise<Response> {
    return this.post<FormData>(`${videoId}/comment/media`, body);
  }
}

const commentsService = new CommentsService();

export const getComments = (videoId: string) =>
  commentsService.getComments(videoId);

export const postComment = (videoId: string, body: FormData) =>
  commentsService.postMediaComment(videoId, body);
